import * as React from 'react';
import { match as Match } from 'react-router';

import { connect } from 'react-redux';

import './Troughs.page.scss';
import { SwordSearch, Header, LogoCentered } from 'src/app/Partials';
import TroughFilterLarge from 'src/app/Partials/Trough/TroughFilterLarge/TroughFilterLarge';
import TroughListLarge from 'src/app/Partials/Trough/TroughListLarge/TroughListLarge';
import { GlobalPrivateState, QueryParemeterPayload, formatMessage } from 'src/api';
import { TroughsDispatcher } from 'src/app/Container';
import { FormattedMessage } from 'react-intl';
import MESSAGES from './Troughs.messages';
import { IsAuthentificatedState } from 'loopback-react-request';
import { Link } from 'react-router-dom';

export interface TroughsPageProps {
  authenticator: IsAuthentificatedState;
  queryState: GlobalPrivateState['queryState'];
  troughs: GlobalPrivateState['troughs'];
}

export interface TroughsPageState {
}

export class TroughsPagePartial extends React.Component<TroughsPageProps, TroughsPageState> {
  constructor(props: TroughsPageProps) {
    super(props);
  }

  public render() {
    const { troughs } = this.props;
    const toStartLogin = formatMessage({...MESSAGES.toStartLogin});
    const toStartCreate = formatMessage({...MESSAGES.toStartCreate});

    return (
      <>
      
        {!this.props.authenticator.isAuthentificated && (
          <div className="header-note">
            <div className="container">
              <FormattedMessage {...MESSAGES.toStart} values={{
                login: <Link to="/">{toStartLogin}</Link>,
                create: <Link to="/register">{toStartCreate}</Link>
              }}/>
            </div>
          </div>
        )}
        <Header />
        <div className="page-dashboard">
          <TroughsDispatcher />
          <div className="page-configuration-list page-troughs-list pb-3 container">
            <div className="container">
              <SwordSearch />
              <div className="row">
                <div className="col-12 p-0">
                  <TroughFilterLarge />
                </div>
              </div>
              <div className="row">
                <TroughListLarge />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  private get filter(): QueryParemeterPayload['filter'] | QueryParemeterPayload['sword'] | undefined {
    return this.props.queryState && this.props.queryState.params && (this.props.queryState.params.filter || this.props.queryState.params.sword);
  }
}

export const TroughsPage = connect((state: GlobalPrivateState) => ({
  queryState: state.queryState,
  troughs: state.troughs,
  authenticator: state.authenticator,
}))(TroughsPagePartial);

export default TroughsPage;